var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join"},[_c('BaseSectionTitle',[_vm._v(" Interesse? ")]),_c('BaseContainer',{staticClass:"my-12"},[_c('MembershipApplication')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }